import { useContext, useMemo } from 'react';
import { ParentContext } from '../ParentContext';
import { useAppUserAccess } from './useAppUserAccess';

export const useAppUserAccessPermissions = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { appUser_state, currentSettings_state } = states ?? {};
  const { gvviSettings } = currentSettings_state ?? {};

  const appUserAccess = useAppUserAccess();
  const { accessLevel: accessLevel_appUser, appUserSession, loggedIn } = appUserAccess ?? {};
  const { appUserEvent } = appUserSession ?? {};

  const { aps_appUserSettings } = gvviSettings ?? {};
  const { appUserDataModifications, appUserViewTypeProp } = aps_appUserSettings ?? {};

  const { appUserDataPermissions, appUserDataPermission_allowed } = useMemo(() => {

    const _appUserDataPermissions = []
    let _appUserDataPermission_allowed;

    if (appUserDataModifications && appUserEvent && appUserViewTypeProp && appUserEvent[appUserViewTypeProp]) {
      const _appUserEventTypes = appUserEvent[appUserViewTypeProp]
      if (_appUserEventTypes) {
        _.forEach(_appUserEventTypes, (auEventType) => {
          if (appUserDataModifications[auEventType]) {
            const permissions = appUserDataModifications[auEventType]
            _.forEach(permissions, (permission) => {
              _appUserDataPermissions.push(permission)
            })
          }
        })
      }
    }

    if (_appUserDataPermissions && _appUserDataPermissions.length > 0) {
      if (_appUserDataPermissions.includes(_viewItemKey)) {
        _appUserDataPermission_allowed = true
      }
    }

    return { appUserDataPermissions: _appUserDataPermissions, appUserDataPermission_allowed: _appUserDataPermission_allowed }
  })

  return { appUserDataPermissions, appUserDataPermission_allowed }

}
